import * as r from 'ramda';
import React from 'react';
import { BrowserRouter } from 'react-router-dom';

import { withReduxProvider } from 'utils';

import { store, persistor } from 'modules';

import { useDeviceID } from './hooks/useDeviceID';
import { GlobalStyle } from './GlobalStyle';
import { Router } from './Router';

const ApplicationBase = () => {
  useDeviceID();

  return (
    <BrowserRouter>
      <GlobalStyle />
      <Router />
    </BrowserRouter>
  );
};

export const Application = r.compose(withReduxProvider(store, persistor))(ApplicationBase);
